/// <amd-module name="Repos/Views/Settings/Repositories/Components/RefsMasterPanel" />
import React = require("react");
import { IBranchesProps } from "Repos/Views/Settings/Branches/Components/Branches/Branches.Props";
import { SimpleGitRef } from "Repos/Views/Settings/Branches/Data/SimpleGitRef";
import { IRepositoriesViewService, permissionsAdditionalData } from "Repos/Views/Settings/Repositories/Services/RepositoriesViewService";
import { IObservableValue, IReadonlyObservableValue } from "VSS/Core/Observable";
import { IVssComponentContext, VssComponent, WrappedComponent } from "VSS/Platform/Layout";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import { IFilter } from "VSSUI/Utilities/Filter";

interface RefsMasterPanelProps {
    filter: IFilter;
    selected: IObservableValue<string>;
}

export class RefsMasterPanel extends VssComponent<RefsMasterPanelProps> {
    private svc: IRepositoriesViewService;
    private additionalData: SimpleGitRef[] | undefined;
    private selectedTab: IReadonlyObservableValue<string | undefined>;

    public constructor(props: RefsMasterPanelProps, context: IVssComponentContext) {
        super(props, context);
        this.svc = context.pageContext.getService<IRepositoriesViewService>("RepositoriesViewService");
        this.selectedTab = this.svc.getSelectedTab();
    }

    public render = (): JSX.Element => {
        if (this.selectedTab && this.selectedTab.value && this.selectedTab.value.indexOf("permission") >= 0) {
            this.additionalData = permissionsAdditionalData;
        }
        return (
            <WrappedComponent<IBranchesProps>
                loadingComponent={renderLoading}
                dependencies={["ms.vss-code-web.settings-branches-content"]}
                wrappedProps={{
                    projectId: this.svc.getProject().id!,
                    repositoryId: this.svc.getSelected().value!.id,
                    onRowActivate: this.onRowActivate,
                    showInPanel: true,
                    filter: this.props.filter,
                    selected: this.svc.getSelectedRefs(),
                    additionalData: this.additionalData,
                    transformSelected: transformSelected
                }}
                wrappedType="settings-branches-component"
            />
        );
    };

    private onRowActivate = (ref: SimpleGitRef) => {
        let selectedRef = ref.ref;

        if (ref.isFolder && this.selectedTab && this.selectedTab.value && this.selectedTab.value.indexOf("policies") >= 0) {
            // if folder in policies, need to append wildcard to get things to work correctly
            selectedRef += "*";
        }

        this.svc.setSelectedRefs(selectedRef);
    };
}

function renderLoading() {
    return <Spinner size={SpinnerSize.large} />;
}

function transformSelected(selected: string | undefined) {
    if (selected && selected.endsWith("*")) {
        return selected.substr(0, selected.length - 1);
    }

    return selected;
}
